import React from 'react'
import { Platform, View } from 'react-native'
import tw from 'tailwind-rn'
import * as Linking from 'expo-linking'

import * as colors from '../../config/colors'
import * as v from '../../config/variables'
import { LocationType } from '../../config/types'
import { HGButton, HGText } from '../HGUI'

type Props = {
  data: LocationType
}

const Location = (props: Props) => {
  const { data } = props
  const { title, phoneNumbers, faxNumbers, emailAddresses, address } = data

  const {
    id: addressId,
    title: addressName,
    address1,
    address2,
    postcode,
    city,
  } = address || {}

  const addressString = [
    // addressName ? `${addressName}, ` : '',
    `${address1}, `,
    address2 ? `${address2}, ` : '',
    `${postcode} ${city}`,
  ].join('')
  const googleMapsLink = `https://maps.google.com/?q=${encodeURIComponent(
    addressString
  )}`

  return (
    <View>
      <View style={tw('mb-4')}>
        <HGText style={{ color: colors.blue, fontFamily: v.FONT_FAMILY_BOLD }}>
          {title}
        </HGText>
      </View>

      {address && (
        <View style={tw('mb-4')}>
          <View key={addressId} style={tw('mb-2')}>
            <HGText>
              {addressName && `${addressName}\n`}
              {`${address1}\n`}
              {address2 && `${address2}\n`}
              {`${postcode} ${city}`}
            </HGText>
          </View>

          <HGButton
            size="small"
            title="Auf Google Maps anschauen"
            onPress={() =>
              Platform.OS === 'web'
                ? window.open(googleMapsLink, '_blank')
                : Linking.openURL(googleMapsLink)
            }
          />
        </View>
      )}

      {phoneNumbers && phoneNumbers.length && (
        <View style={tw('mb-2')}>
          {phoneNumbers.map(({ label, phoneNumber }) => (
            <View
              key={`${label}-${phoneNumber}`}
              style={tw('flex flex-row mb-1')}
            >
              <View style={tw('flex-shrink mr-2')}>
                <HGText key={phoneNumber}>{label}:</HGText>
              </View>

              <View style={tw('flex-grow')}>
                <HGText bold>{phoneNumber}</HGText>
              </View>
            </View>
          ))}
        </View>
      )}

      {faxNumbers && faxNumbers.length && (
        <View style={tw('mb-2')}>
          {faxNumbers.map(({ label, faxNumber }) => (
            <View
              key={`${label}-${faxNumber}`}
              style={tw('flex flex-row mb-1')}
            >
              <View style={tw('flex-shrink mr-2')}>
                <HGText>{label || 'Fax'}:</HGText>
              </View>

              <View style={tw('flex-grow')}>
                <HGText bold>{faxNumber}</HGText>
              </View>
            </View>
          ))}
        </View>
      )}

      {emailAddresses && emailAddresses.length && (
        <View style={tw('mb-2')}>
          {emailAddresses.map(({ label, emailAddress }) => (
            <View
              key={`${label}-${emailAddress}`}
              style={tw('flex flex-row mb-1')}
            >
              <View style={tw('mr-2')}>
                <HGText>{label || 'E-Mail-Adresse'}:</HGText>
              </View>

              <View style={tw('flex-grow')}>
                <HGText bold>{emailAddress}</HGText>
              </View>
            </View>
          ))}
        </View>
      )}

      {/* <HGText>{JSON.stringify(data)}</HGText> */}
    </View>
  )
}

export default Location
